import { reportError } from "../errorHelper";

export const formatDate = (value) => {
  let orderDate = new Date(value);

  let day = orderDate.getDate();
  let month = orderDate.getMonth() + 1;
  let year = orderDate.getFullYear();
  let date_val = `${month < 10 ? `0${month}` : month}.${day < 10 ? `0${day}`: day}.${year}`;

  return date_val;
};

export const formatEstimatedDeliveryDate = (deliveryDate) => {
  try {
    let endDeliveryDate;
      // Split the delivery date range into parts
    const parts = deliveryDate.split(" - ");

    // Extract the start and end date strings
    const startDateString = parts[0].split(", ")[1];
    const endDateString = parts[1].split(", ")[1];

    // Convert the date strings to Date objects
    const startDate = new Date(startDateString + ", " + new Date().getFullYear());
    endDeliveryDate = new Date(endDateString + ", " + new Date().getFullYear());

    // Format the date objects without the day
    const formattedStartDate = startDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
    const formattedEndDate = endDeliveryDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });

    // Create the final estimated date
    return {dateString: `Estimated delivery ${formattedStartDate} - ${formattedEndDate}`, endDate: endDeliveryDate}
  } catch (error) {
    reportError("Error in formatEstimatedDeliveryDate")
    reportError(error)
  }
};
